import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
    Lookup
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarTiposVeiculosDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class TiposVeiculosBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
        this.tipoMoeda = [
            { id: 0, descricao: "Real" },
            { id: 1, descricao: "Unidade Fiscal" },
        ]
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Tipos de Veículos">
                    <DataGrid
                        dataSource={criarTiposVeiculosDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'id'} caption={"#"} width={'150'} allowEditing={false} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Column dataField="tipoMoeda" caption="Tipo Moeda" width={125}>
                            <Lookup dataSource={this.tipoMoeda} displayExpr="descricao" valueExpr="id" />
                        </Column>
                        <Column dataField={'valor'}
                            caption={"Valor"}
                            dataType={"number"}
                            editorType={"dxNumberBox"}
                            editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                            format={uiInfo.formatoNumerico.n2} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
